const AbstractGuidlinesData = {
  title: "Abstract submission guidelines",

  content: [
    {
      heading: "Submitting Author:",
      text: `The author that submits the abstract, to whom all correspondence will be addressed and sent. The Submitting Author is assumed to be the Presenting Author unless otherwise indicated.`,
    },

    {
      heading: "Title",
      text: "Maximum 20 words",
    },

    {
      heading: "Keywords",
      text: "Maximum 4",
    },

    {
      heading: "Abstract body",
      list: [
        "Maximum 300 words, including the following sections",
        "Objectives: At least 2 clear and measurable objectives",
        "Background: A brief statement on why the study was conducted",
        "Methods: The methods of study or experimental approach must be briefly defined",
        "Results: A summary of the study results, including sufficient detail to support the conclusions",
        "Conclusions: A statement explaining the significance of the study and its implications for further research",
      ],
    },

    {
      heading: "Authors",
      list: ["Maximum 11", "Include full names with institution and country"],
    },

    {
      heading: "Preferred Presentation Type",
      text: `You may indicate your preferred presentation type – Oral or ePoster – but the Abstract Selection Committee will make the final format determination`,
    },

    {
      heading: "Disclose conflict of interest and accept terms and conditions",
      text: `If you have any questions regarding your abstract contact us at: dr.pawankverma@gmail.com, draashutoshkumarr@gmail.com`,
    },

    {
      heading: "Operative Video Submission Guidelines",
      text: "Operative Video Case-Based Learning Session – “E” MISS–CVJ 2026",
      list: [
        "Submissions are invited for Craniovertebral Junction (CVJ) surgery, Unilateral Biportal Endoscopy (UBE), and Monoportal Endoscopic Spine Surgery.",
        "It is mandatory that each video clearly state FOUR major learning objectives at the beginning of the presentation.",
        "Videos should follow a structured format including a brief case introduction, operative steps, critical intraoperative points, and postoperative outcome.",
        "The video must be 6–8 minutes long; longer submissions will not be considered.",
        "Videos must be submitted in MP4 or MOV format with a minimum resolution of Full HD (1080p).",
        "Narration should be clear, concise, and educational; background music and promotional content are discouraged.",
        "Emphasis should be on reproducible techniques, anatomical clarity, and sound surgical judgment rather than operative showmanship.",
        "All submissions will undergo peer review based on educational value, technical quality, relevance, and ability to stimulate discussion.",
        "Selected videos will be presented in a moderated, interactive case-based learning session.",
        "Presenting authors must be available for faculty and audience discussion during the session.",
      ],
    },

    {
      heading: "Guidelines for e-Poster / Paper Presentation",
      text: "An e-poster/paper is an electronic version of traditional boards and is displayed on monitor screens using PowerPoint slides.",
      list: [
        "An e-poster should consist of a maximum of 5 PowerPoint slides. There is no specific restriction on number of slides for award/free paper, but it should be within the allotted time limit.",
        "The total duration for presentation will be 03+01 minutes for e-poster and 06+02 minutes for award/free paper and discussion respectively.",
        "Slides should include title, methodology, results, and conclusion.",
        "Do not include any videos or animations.",
        "Text, figures, tables, or images may be included.",
        "Use Times New Roman or Calibri fonts only.",
        "Font size should not be smaller than 24.",
        "Use the template attached for making the presentation.",
        "Use clear headings and adequate spacing between sections.",
        "Pictures and graphics should be of good resolution and clearly labelled.",
        "Text should not be obscured by images.",
        "Use of personal laptops for presentation is not permitted.",
        "Presentations must be submitted at the preview desk preferably one week in advance on: traumalucknow2024@gmail.com.",
        "Strictly adhere to the allotted time. Exceeding time limits will result in negative marking.",
        "Mac users must convert Keynote files to MS PowerPoint format before submission.",
      ],
    },

    {
      heading: "For Best Award Paper",
      list: [
        "Among the submitted abstract and poster, the award committee will decide five best paper and poster for award session.",
        "Submission of papers and posters must be completed on or before 1st April 2026 for consideration into AWARD category",
      ],
    },
  ],
};

export default AbstractGuidlinesData;
